import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Link } from 'lucide-react';
import { formatCurrency, formatDate } from '../utils/formatters';

export const MatchConfirmDialog = ({
  open,
  onOpenChange,
  selectedRecordedTxn,
  selectedBankTxn,
  matching,
  handleManualMatch,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Confirm Manual Match</DialogTitle>
        <DialogDescription>Are you sure you want to match these two transactions?</DialogDescription>
      </DialogHeader>
      {selectedRecordedTxn && selectedBankTxn && (
        <div className="space-y-3">
          <div className="p-3 bg-amber-50 rounded border border-amber-200">
            <p className="text-xs text-amber-600 font-medium">Recorded Transaction</p>
            <p className="font-medium">{selectedRecordedTxn.investor_name}</p>
            <p>{formatCurrency(selectedRecordedTxn.amount)} — {formatDate(selectedRecordedTxn.transaction_date)}</p>
            <p className="text-sm text-gray-500">{selectedRecordedTxn.reference || selectedRecordedTxn.notes || 'No reference'}</p>
          </div>
          <div className="flex items-center justify-center"><Link className="h-5 w-5 text-blue-500" /></div>
          <div className="p-3 bg-red-50 rounded border border-red-200">
            <p className="text-xs text-red-600 font-medium">Bank Transaction</p>
            <p className="font-medium">{selectedBankTxn.description || 'No description'}</p>
            <p>{formatCurrency(selectedBankTxn.amount)} — {formatDate(selectedBankTxn.posting_date || selectedBankTxn.value_date)}</p>
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={handleManualMatch} disabled={matching} data-testid="recon-confirm-match-btn" className="bg-green-600 hover:bg-green-700 text-white">
          {matching ? 'Matching...' : 'Confirm Match'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
